import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addInsurancePayors = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.create_insurance_payor',
    body
  );
  return data;
});
export const updateInsurancePayors = catchAsync(async ({ body, id }) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_insurance_payor',
    `/api/resource/Insurance Payor/${id}`,
    body
  );
  return data;
});
export const deleteInsurancePayors = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Insurance Payor`
    `/api/resource/Insurance Payor/${record}`
  );
  return data;
});
export const getInsurancePayorsById = catchAsync(async (id) => {
  // /api/resource/Insurance Payor?fields=["name","disabled","insurance_claim_credit_days"]
  const { data } = await axiosInstance.get(
    // '/api/method/technoerp.services.get_insurance_payors'
    `/api/resource/Insurance Payor/${id}`
  );
  return data;
});
export const getInsurancePayors = catchAsync(async () => {
  // /api/resource/Insurance Payor?fields=["name","disabled","insurance_claim_credit_days"]
  const { data } = await axiosInstance.get(
    // '/api/method/technoerp.services.get_insurance_payors'
    '/api/resource/Insurance Payor?fields=["name","disabled","insurance_claim_credit_days","insurance_payor_name"]'
  );
  return data;
});

export const getMedicalCodeStandards = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_medical_code_standards'
  );
  return data;
});
export const getReceivableAccounts = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_receivable_accounts'
  );
  return data;
});
export const getExpenseAccounts = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_expense_accounts'
  );
  return data;
});
